import type { CJobOffersTranslations } from "./pl";

export const en: CJobOffersTranslations = {
  emptyData: "No data to display.",
  emptyList: "There are no offers that meet the selected criteria.",
  filterCategory: "All categories",
  filterProvince: "All voivodeships",
  filterCity: "All cities",
  filterSubmit: "Search",
  filterReset: "Reset filters",
  filterLabelCategory: "Category",
  filterLabelProvince: "Voivodeship",
  filterLabelCity: "City",
  referenceNumber: "Reference number",
  publicationDate: "Date posted",
  tasksHeading: "You will be responsible for:",
  expectationsHeading: "We expect from you:",
  offerHeading: "We offer:",
  applyButton: "Apply",
  goToForm: "Go to the form",
  attachments: "Attachments",
  download: "Download",
  readMore: "Read more ->",
  backToList: "<- Back to job offers",
  formatDate: (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)} ${months[month]} ${m[1]}`;
  },
  formatFileSize: (bytes) => {
    if (!bytes || bytes < 0) return "0 B";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  },
};
